// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/api/changeability.proto (package knop.ui.v1.api, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Action_Changeability } from "../model/action_pb.js";
import { ResponseStatus } from "./util/response_status_pb.js";

/**
 * @generated from message knop.ui.v1.api.ChangeabilityRequest
 */
export class ChangeabilityRequest extends Message<ChangeabilityRequest> {
  /**
   * @generated from field: string action_guid = 1;
   */
  actionGuid = "";

  /**
   * @generated from field: knop.ui.v1.model.Action.Changeability changeability = 2;
   */
  changeability = Action_Changeability.UNKNOWN;

  /**
   * @generated from field: string instance_id = 3;
   */
  instanceId = "";

  constructor(data?: PartialMessage<ChangeabilityRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.ChangeabilityRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "action_guid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "changeability", kind: "enum", T: proto3.getEnumType(Action_Changeability) },
    { no: 3, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeabilityRequest {
    return new ChangeabilityRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeabilityRequest {
    return new ChangeabilityRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeabilityRequest {
    return new ChangeabilityRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeabilityRequest | PlainMessage<ChangeabilityRequest> | undefined, b: ChangeabilityRequest | PlainMessage<ChangeabilityRequest> | undefined): boolean {
    return proto3.util.equals(ChangeabilityRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.ChangeabilityResponse
 */
export class ChangeabilityResponse extends Message<ChangeabilityResponse> {
  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 1;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  constructor(data?: PartialMessage<ChangeabilityResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.ChangeabilityResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeabilityResponse {
    return new ChangeabilityResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeabilityResponse {
    return new ChangeabilityResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeabilityResponse {
    return new ChangeabilityResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeabilityResponse | PlainMessage<ChangeabilityResponse> | undefined, b: ChangeabilityResponse | PlainMessage<ChangeabilityResponse> | undefined): boolean {
    return proto3.util.equals(ChangeabilityResponse, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.CanUpdateChangeabilityRequest
 */
export class CanUpdateChangeabilityRequest extends Message<CanUpdateChangeabilityRequest> {
  /**
   * @generated from field: string action_guid = 1;
   */
  actionGuid = "";

  /**
   * @generated from field: knop.ui.v1.model.Action.Changeability changeability = 2;
   */
  changeability = Action_Changeability.UNKNOWN;

  /**
   * @generated from field: string instance_id = 3;
   */
  instanceId = "";

  constructor(data?: PartialMessage<CanUpdateChangeabilityRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.CanUpdateChangeabilityRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "action_guid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "changeability", kind: "enum", T: proto3.getEnumType(Action_Changeability) },
    { no: 3, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CanUpdateChangeabilityRequest {
    return new CanUpdateChangeabilityRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CanUpdateChangeabilityRequest {
    return new CanUpdateChangeabilityRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CanUpdateChangeabilityRequest {
    return new CanUpdateChangeabilityRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CanUpdateChangeabilityRequest | PlainMessage<CanUpdateChangeabilityRequest> | undefined, b: CanUpdateChangeabilityRequest | PlainMessage<CanUpdateChangeabilityRequest> | undefined): boolean {
    return proto3.util.equals(CanUpdateChangeabilityRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.CanUpdateChangeabilityResponse
 */
export class CanUpdateChangeabilityResponse extends Message<CanUpdateChangeabilityResponse> {
  /**
   * @generated from field: knop.ui.v1.api.CanUpdateChangeabilityResponse.CanUpdate result = 1;
   */
  result = CanUpdateChangeabilityResponse_CanUpdate.UNKNOWN;

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  constructor(data?: PartialMessage<CanUpdateChangeabilityResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.CanUpdateChangeabilityResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "result", kind: "enum", T: proto3.getEnumType(CanUpdateChangeabilityResponse_CanUpdate) },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CanUpdateChangeabilityResponse {
    return new CanUpdateChangeabilityResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CanUpdateChangeabilityResponse {
    return new CanUpdateChangeabilityResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CanUpdateChangeabilityResponse {
    return new CanUpdateChangeabilityResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CanUpdateChangeabilityResponse | PlainMessage<CanUpdateChangeabilityResponse> | undefined, b: CanUpdateChangeabilityResponse | PlainMessage<CanUpdateChangeabilityResponse> | undefined): boolean {
    return proto3.util.equals(CanUpdateChangeabilityResponse, a, b);
  }
}

/**
 * @generated from enum knop.ui.v1.api.CanUpdateChangeabilityResponse.CanUpdate
 */
export enum CanUpdateChangeabilityResponse_CanUpdate {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: YES = 1;
   */
  YES = 1,

  /**
   * @generated from enum value: NO = 2;
   */
  NO = 2,

  /**
   * @generated from enum value: ERROR = 3;
   */
  ERROR = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(CanUpdateChangeabilityResponse_CanUpdate)
proto3.util.setEnumType(CanUpdateChangeabilityResponse_CanUpdate, "knop.ui.v1.api.CanUpdateChangeabilityResponse.CanUpdate", [
  { no: 0, name: "UNKNOWN" },
  { no: 1, name: "YES" },
  { no: 2, name: "NO" },
  { no: 3, name: "ERROR" },
]);

